import env from './env';
import { buildOrigin } from './helpers';

export const IS_USING_OLD_SSO = env.sso.isUsingOldSSO;
export const SSO_URL = env.sso_url;
export const NO_IMAGE_URL = env.no_image_url;
export const WEB_REPORTS_URL = env.web_reports_url;
export const SALES_REPORTS_URL = env.sales_reports_url;
export const API_BASE_URL = __DEV__
	? 'http://localhost:55086/api/'
	: buildOrigin();
export const REQUEST_FAILED = 'request_failed';
export const QS_DATE_FORMAT = 'DD-MM-YYYY';
export const PRIVACY_POLICY_LINK = '//policies.snapon.com/franchisee';

export const PRODUCT_GROUPS_CODES = {
	'hand-tools': 'HT',
	'power-tools': 'PT',
	'tool-storage': 'TS',
	'shop-and-tech': 'ES',
	diagnostics: 'DI',
};

export const PRODUCT_GROUPS = {
	'hand-tools': 'Hand Tools',
	'power-tools': 'Power Tools',
	'tool-storage': 'Tool Storage',
	'shop-and-tech': 'Shop and Tech',
	diagnostics: 'Diagnostics',
};

export const PAGINATION = {
	sizes: [15, 20, 25], // eslint-disable-line no-magic-numbers
	defaultSize: 15,
};

export const PENDING_ORDER_NUMBER = 'Pending';

export const INTERNAL_ERROR = 500;
export const BAD_REQUEST = 400;
export const FORBIDDEN = 403;

export const MONTHS_IN_YEAR = 12;
export const DATE_RANGE_DEFAULT_DAYS = 30;

export const HOURS_RANGE = 14;

export const SIDEBAR_COUNTRY_FOR_USERS = 'Generic';
export const COUNTRIES = {
	UK: 'United Kingdom',
	US: 'USA',
	CA: 'Canada',
	IE: 'Ireland',
	AU: 'Australia',
	NZ: 'New Zealand',
};

export const COUNTRY_SHORT_NAMES = {
	UK: 'GB',
	US: 'US',
	CA: 'CA',
	IE: 'IE',
	AU: 'AU',
	NZ: 'NZ',
};

export const MAX_PAGES_NUMBER = 15;

export const LANGUAGES = ['EN', 'FR'];

export const LOCALES = {
	EN: 'en-US',
	FR: 'fr-CA',
};

export const NOT_ON_FILE = 'not on file';
export const MAX_DROPSHIP_CHANGES_SAME_ITEM = 2;

export const CUSTOMER_PHONE_NUMBER = {
	USA: '1-877-762-7662',
	Canada: '1-877-762-7662',
	Australia: '+61 2 9837 9166',
	'New Zealand': '+61 2 9837 9166',
	'United Kingdom': '01536 413838',
	Ireland: '01536 413838',
};



// WEBPACK FOOTER //
// ./src/config/constants.js